<template>
  <div class="edit-adorn">
    <div class="decoration-wrapper">
      <div class="decoration" :class="[adornSize]">
        <div class="outer" :class="{ sign: signType === 'new' }">
          <div class="decoration_img">
            <img src="@imgs/newAlLib.png" alt="" @click="imgMsn('new')" />
          </div>
        </div>
        <div class="outer" :class="{ sign: signType === 'hot' }">
          <div class="decoration_img">
            <img src="@imgs/hotAlLib.png" alt="" @click="imgMsn('hot')" />
          </div>
        </div>
        <div class="outer" :class="{ sign: signType === 'custom' }" @click="imgMsn('custom')">
          <div class="decoration_img custom" @click="toMember">
            <i v-show="!adornmentImg" class="el-icon-plus custom-bg"></i>
            <img v-show="adornmentImg" :src="adornmentImg" />
          </div>
        </div>
      </div>
      <div v-if="signType === 'custom' && isShow" class="custom-wrapper">
        <label class="uploadAdornmentButton" for="uploadAdornmentButton" @click="uploadAdornButtonHandler($event)">
          + 上传装饰
          <input type="file" id="uploadAdornmentButton" ref="upAdornment" value="adornmentImgValue" accept="image/png" @input="uploadAdornment($event)" />
        </label>
        <div class="custom-tip">
          建议上传40*40像素的png图片
        </div>
      </div>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>

<script>
import TipDialog from '@components/common/TipDialog.vue'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  name: 'adornment',
  data() {
    return {
      signType: 'no',
      adornment: this.decoration,
      adornmentImg: ''
    }
  },
  mixins: [compareVipRight],
  props: {
    decoration: {
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  components: {
    TipDialog
  },
  computed: {
    isShow() {
      return this.compare({ type: 'boole', key: 'customAdornment' })
    },
    adornSize() {
      return this.size
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  watch: {
    // 装饰设置样式初始化
    decoration: function(newValue, oldValue) {
      this.adornment = newValue
      if (newValue) {
        if (newValue === 'new.png') {
          this.signType = 'new'
        } else if (newValue === 'hot.png') {
          this.signType = 'hot'
        } else {
          this.adornmentImg = newValue
          this.signType = 'custom'
          this.$emit('signTypeChange', this.signType)
        }
      } else {
        this.signType = 'no'
      }
    }
  },
  methods: {
    // 装饰设置按钮点击
    imgMsn(type) {
      this.signType = this.signType === type ? 'no' : type

      if (this.signType == 'new' || this.signType === 'hot') {
        this.adornment = this.signType + '.png'
      } else if (this.signType === 'custom') {
        let start = this.adornmentImg.indexOf('attach/')
        if (start > -1) {
          this.adornment = this.adornmentImg.substring(start)
        } else {
          this.adornment = this.adornmentImg
        }
      } else {
        this.adornment = ''
      }
      this.$emit('signTypeChange', this.signType)
      this.$emit('adornmentMsn', this.adornment)
    },
    // 自定义装饰图片更新
    uploadAdornment(event) {
      if (this.$refs.upAdornment.value === '') {
        return
      }
      let _this = this
      let file = event.target.files[0]
      this.fileName = file.name
      if (!/\.(png|PNG)$/.test(event.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = function() {
        _this.adornmentImg = this.result
        _this.$emit('adornmentMsn', _this.adornmentImg)
      }
      this.$refs.upAdornment.value = ''
    },
    async toMember() {
      if (!(await this.compareRight({ type: 'boole', key: 'customAdornment' }))) {
        this.$refs.memberDialog.visible = true
        return
      }
    },
    uploadAdornButtonHandler(e) {
      this.getVipInfo()
      if (!this.compare({ type: 'boole', key: 'customAdornment' })) {
        this.$refs.memberDialog.visible = true
        e.preventDefault()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$--mini-adorn-button-outer-size: 40px;
$--mini-adorn-button-inner-size: 36px;
$--small-adorn-button-outer-size: 50px;
$--small-adorn-button-inner-size: 40px;
@mixin set-size($adorn-button-width, $adorn-button-height) {
  width: $adorn-button-width;
  height: $adorn-button-height;
}

.edit-adorn {
  width: 100%;
  .decoration-wrapper {
    width: 100%;
    .decoration {
      display: flex;
      justify-content: space-between;
      &.mini {
        .outer {
          @include set-size($--mini-adorn-button-outer-size, $--mini-adorn-button-outer-size);
          .decoration_img {
            @include set-size($--mini-adorn-button-inner-size, $--mini-adorn-button-inner-size);
          }
        }
      }
      &.small {
        .outer {
          @include set-size($--small-adorn-button-outer-size, $--small-adorn-button-outer-size);
          .decoration_img {
            @include set-size($--small-adorn-button-inner-size, $--small-adorn-button-inner-size);
          }
        }
      }
      .outer {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #dcdfe6;
        .decoration_img {
          width: 40px;
          height: 40px;
          border: 1px dashed #dcdfe6;
          cursor: pointer;
          img {
            width: 100%;
          }
          &.custom {
            position: relative;
            .custom-bg {
              position: absolute;
              transform: translate(-50%, -50%);
              left: 50%;
              top: 50%;
              color: #df5813;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }

      .sign {
        border-color: #df5813;
      }
    }
    .custom-tip {
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      font-size: 14px;
      margin-top: 6px;
      padding: 4px;
      text-align: center;
      line-height: 20px;
      width: 100px;
    }
    .custom-wrapper {
      .uploadAdornmentButton {
        width: 100px;
        height: 24px;
        background: #df5813;
        color: #fff;
        border-radius: 15px;
        font-size: 14px;
        display: flex;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin: 10px 0;
        cursor: pointer;
      }
      input {
        display: none;
      }
    }
  }
}
</style>
